import { render, staticRenderFns } from "./EditCollaboratorsModal.vue?vue&type=template&id=99abc428&scoped=true"
import script from "./EditCollaboratorsModal.vue?vue&type=script&lang=js"
export * from "./EditCollaboratorsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99abc428",
  null
  
)

export default component.exports